import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const StaffFormStyles = styled.div`
  animation: ${fadeIn} 0.2s ease-out;

  .inputsRow {
    display: flex;
    gap: ${({ theme }) => theme.spacing[16]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};

    .inputContainer {
      flex: 1;
    }
  }

  .roleContainer {
    margin-bottom: ${({ theme }) => theme.spacing[20]};
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
    min-height: 40px;

    button {
      animation: ${fadeIn} 0.25s ease-out;
    }
  }
`;
